module.exports = __webpack_public_path__ + "static/media/flickr.991cdbdd.svg";